module.exports = __webpack_public_path__ + "img/icon_map_511.898923bf.png";